import {Stack, ToggleButton, ToggleButtonGroup, Button} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import {parseISO} from "date-fns";
import moment from "moment-timezone";
import ReplayIcon from '@mui/icons-material/Replay';
import DashboardLastUpdatedTimer from "./DashboardLastUpdatedTimer.js";
import {FormatListBulleted, Tablet} from "@mui/icons-material";
import Constants from "../../../../utils/constants.js";

function DashboardHeaderControls({selectedDate, onDateChange, onReload, lastUpdated, viewMode, onViewModeChange}) {
    const formatDate = (days) => {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return date.toISOString().split('T')[0];
    };

    return (
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" flexWrap="wrap"
               sx={{width: '100%'}}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                <ToggleButtonGroup
                    color="primary"
                    exclusive
                    size="large"
                    className="dashboard-button-pickers"
                    value={selectedDate}
                    onChange={(event, newValue) => {
                        if (newValue !== null) onDateChange(formatDate(newValue));
                    }}
                >
                    <ToggleButton
                        value={-1}
                        className={selectedDate === formatDate(-1) ? "toggle-button button-selected-green" : "toggle-button"}
                    >
                        Hier
                    </ToggleButton>
                    <ToggleButton
                        value={0}
                        className={selectedDate === formatDate(0) ? "toggle-button button-selected-green" : "toggle-button"}
                    >
                        Aujourd'hui
                    </ToggleButton>
                    <ToggleButton
                        value={+1}
                        className={selectedDate === formatDate(+1) ? "toggle-button button-selected-green" : "toggle-button"}
                    >
                        Demain
                    </ToggleButton>
                </ToggleButtonGroup>

                <DatePicker
                    value={parseISO(selectedDate)}
                    displayWeekNumber={true}
                    onChange={(newDate) => {
                        onDateChange(moment(newDate).format("YYYY-MM-DD"));
                    }}
                />


            </Stack>

            <Stack direction="row" spacing={2} alignItems="center">
                <DashboardLastUpdatedTimer lastUpdated={lastUpdated}/>
                <Button onClick={onReload}>
                    <ReplayIcon/>
                </Button>
            </Stack>

            {onViewModeChange && (
                <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={(e, newMode) => {
                        if (newMode) onViewModeChange(newMode);
                    }}
                    size="small"
                >
                    <ToggleButton value={Constants.DASHBOARD_VIEW_MODE_LIST}>
                        <Tablet/>
                    </ToggleButton>
                    <ToggleButton value={Constants.DASHBOARD_VIEW_MODE_OLD}>
                        <FormatListBulleted/>
                    </ToggleButton>
                </ToggleButtonGroup>
            )}
        </Stack>
    );
}

export default DashboardHeaderControls;
